var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "transparent",
    rx: 18.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#46466B",
    d: "M127.982 18.29v91.419c0 10.06-8.231 18.291-18.291 18.291h-91.4C8.23 128 0 119.769 0 109.709V18.291C0 8.23 8.23 0 18.29 0h91.419C119.769 0 128 8.23 128 18.29zm-39.49-7.187-24.51 24.51-24.51-24.51-9.511 9.51 25.186 25.188c4.884 4.883 12.786 4.883 17.67 0l25.186-25.187zm9.51 96.301L72.817 82.218c-4.883-4.884-12.785-4.884-17.669 0l-25.186 25.186 9.51 9.512 24.51-24.51 24.51 24.51zm18.877-18.876-24.51-24.51 24.51-24.51-9.511-9.51-25.187 25.186c-4.883 4.883-4.883 12.785 0 17.669l25.187 25.186zM20.577 98.04l25.187-25.186c4.884-4.884 4.884-12.786 0-17.67L20.577 29.998l-9.511 9.511 24.51 24.51-24.51 24.51z"
  })));
};
export default SvgIcon;